import { ValueddedNotCombinable } from '@cemex-core/cmx-api';
import { OrderBuilderActions, RESET_BUILDER } from '../../../actions/order-builder.actions';
import { ProductsActions, ProductsActionTypes } from '../actions/products.actions';
import { ExtendedCommercialProductRecommendation } from '../models/extended-commercial-product';

/**
 * The store's array of products available to the customer. (Probably in the context of a given jobsite, but this is
 * not explicitly stated.)
 */
export interface ProductsState {
  loading: boolean;
  availableProducts: ExtendedCommercialProductRecommendation[];
  valueAddedsNotCombinable: ValueddedNotCombinable[];
}

/**
 * The initial state of the product-list:  Not loading and empty.
 * @type {{availableProducts: any[]; loading: boolean}}
 */
export const initialState: ProductsState = {
  loading: false,
  availableProducts: [],
  valueAddedsNotCombinable: [],
};

/**
 * Updates the state of the product-list in the specification step of the one-click order workflow.
 * @param {ProductsState} state
 * @param {ProductsActions | OrderBuilderActions} action
 * @return {ProductsState}
 */
export function productsReducer(state = initialState, action: ProductsActions | OrderBuilderActions): ProductsState {
  switch (action.type) {
    case ProductsActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as ProductsState;
    }
    case ProductsActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        availableProducts: action.payload.productRecommendationCom,
        valueAddedsNotCombinable: action.payload.value_addeds_na,
      } as ProductsState;
    }
    case RESET_BUILDER:
    case ProductsActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
